import { DashboardActionKeys as keys } from './dashboardActionKeys';
import { DashboardActionTypes } from './dashboardActionTypes';
import { ISalesDashboardApiResponse } from './dashboardInterfaces';

export interface IDashboardState {
  loading: boolean;
  sales?: ISalesDashboardApiResponse;
}

const initialState: IDashboardState = {
  loading: false
};

export function dashboardReducer(state: IDashboardState = initialState, action: DashboardActionTypes): IDashboardState {
  switch (action.type) {
    case keys.FETCH_SALES_DASHBOARD:
      return {
        ...state,
        loading: true
      };
    case keys.SET_SALES_DASHBOARD:
      return {
        ...state,
        sales: action.payload
      };
    default:
      return state;
  }
}
